const Breakpoints = {
  IPAD_PORTRAIT: '768px',
  IPAD_LANDSCAPE: '1024px',
  LAPTOP: '1366px'
};

export default Breakpoints;
